import { render, staticRenderFns } from "./suitcase.vue?vue&type=template&id=c20da12e"
import script from "./suitcase.vue?vue&type=script&lang=js"
export * from "./suitcase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports